export default __webpack_public_path__ + "static/media/33.2783c170.jpg";